import { render, staticRenderFns } from "./Projectapplication.vue?vue&type=template&id=d8c3fae2&scoped=true&"
import script from "./Projectapplication.vue?vue&type=script&lang=js&"
export * from "./Projectapplication.vue?vue&type=script&lang=js&"
import style0 from "./Projectapplication.vue?vue&type=style&index=0&id=d8c3fae2&scoped=true&lang=css&"
import style1 from "./Projectapplication.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c3fae2",
  null
  
)

export default component.exports